<template>
  <v-container>
    <v-card>
      <v-card-title class="mx-1">Plan Nacional de Desarrollo</v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex
            xs12
            sm7
            class="mx-4"
          >Conozca cómo avanza la implementación del Acuerdo Final a través del Plan Nacional de Desarrollo.</v-flex>
          <v-flex xs12 sm4>
            
            <v-select
              :items="DataCuatrenios"
              v-model="Dataplannacionaldesarrollo"
              item-text="periodo"
              item-value="periodo"
              label="Seleccione el PND cuya asociación con el PMI desea consultar"
              @change="cambiarPeriodo"
            ></v-select>
            
          </v-flex>
          <v-flex>
            <v-btn v-show="false" color="primary" width="5px" height="20px !important" @click="get_mensaje">json</v-btn>
          </v-flex>
        </v-layout>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>Plan Nacional de Desarrollo {{Dataplannacionaldesarrollo.periodo}} "{{Dataplannacionaldesarrollo.nombre}}"</v-expansion-panel-header>
            <v-expansion-panel-content
              style="text-align: justify;"
            >{{Dataplannacionaldesarrollo.descripcion}}</v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-card>
          <v-card-title>Asociación de los indicadores del Plan Marco de Implementación y el Plan Nacional de Desarrollo {{Dataplannacionaldesarrollo.periodo}} por punto del Acuerdo</v-card-title>
          <v-card-text>
            Porcentaje de asociación del indicadores PMI al PND {{Dataplannacionaldesarrollo.periodo}}.
            <v-row>
              <v-col
                xs12
                sm4
                v-for="item of gpuntos"
                v-bind:key="item.idpunto"
                class="eventbtn"
                style="display: grid; text-align: center; "
                @click="cargarpacto(item.idpunto)"
              >
                <v-flex>
                  <div
                    class="subtitle-1 font-weight-bold"
                    style="line-height: normal;"
                    :style="{ color: item.color }"
                  >{{ item.nombre }}</div>
                </v-flex>
                <v-flex>
                  <img
                    width="80px"
                    class="gray"
                    v-bind:src="'data:image/jpeg;base64,' + item.icono"
                  />
                </v-flex>
                <v-flex align-self-end>
                  <v-btn
                    small
                    :color="item.color"
                    class="subtitle-1 font-weight-bold"
                    style="color:white"
                  >{{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(
              item.avance)}} %</v-btn>
                </v-flex>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card v-show="showpacto">
          <v-card-title  v-show="titlePacto">Pactos del PND alineados con indicadores del "{{DataPuntoSelecionado.nombre}}" del PMI</v-card-title>
          <v-card-title  v-show="titleTransf">Transformaciones del PND alineados con indicadores del "{{DataPuntoSelecionado.nombre}}" del PMI</v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                xs12
                sm4
                v-for="item of DataPactosSeleccionados"
                v-bind:key="item.idnivelpnd"
                class="eventbtn"
                style="display: grid; text-align: center; "
                @click="cargardetalle(item.idnivelpnd)"
              >
                <v-flex>
                  <img
                    width="60px"
                    class="gray"
                    v-bind:src="item.imagen"
                  />
                </v-flex>
                <v-flex>
                  <div
                    class="font-weight-light"
                    :style="{ color: DataPuntoSelecionado.color }"
                  >{{ item.nombrecorto }}</div>
                </v-flex>
                <v-flex>
                  <div v-show="titleLineas"
                    class="font-weight-medium text-4" style="white-space: pre-wrap;"
                  >( {{ item.lineas }} Lineas - {{ item.indicadores }} indicadores) </div>
                  <div v-show="titleCatalizador"
                    class="font-weight-medium text-4" style="white-space: pre-wrap;"
                  >( {{ item.lineas }} Catalizador - {{ item.indicadores }} indicadores) </div>
                </v-flex>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import store from "../../stores/index.js"
import { mapActions, mapGetters } from "vuex";
export default {
  name: "comparativogeneral",
  data() {
    return {
      Dataplannacionaldesarrollo: [],
      DataCuatrenios: [],
      DataPuntoSelecionado: [],
      showpacto: false,
      DataPactosSeleccionados: [],
      vartext: [],
      titleTransf: true,
      titleCatalizador:true,
      titlePacto: false,
      titleLineas:false
    };
  },
  methods: {
    ...mapActions(["puntoPND", "get_plannacionaldesarrollo", "get_nivelespnd", "get_nivelespndbypunto","procesarpndjson_","get_mensaje"]),
    cargarpacto(item) {
      this.showpacto = true;
      this.DataPuntoSelecionado = this.gpuntos.filter(
        (p) => p.idpunto == item
      )[0];

      this.get_nivelespndbypunto({
        params: {
          idpunto: item,
          periodo:this.Dataplannacionaldesarrollo.periodo,
        }
      })
    },

    cambiarPeriodo(value)
    {
      
      this.showpacto = false;

      const resultadosFiltrados=this.gplanesnacionaldesarrollo.filter(item=> item.periodo == value) ;
      this.Dataplannacionaldesarrollo = resultadosFiltrados[0] ;
      

      if(value=="2022-2026")
    {
      console.log('Valor seleccionado:', value);
      this.titleTransf=true;
      this.titleCatalizador=true;
      this.titlePacto=false;
      this.titleLineas=false;
    }
    else
    {
      console.log('Valor seleccionado:', value);
      this.titleTransf=false;
      this.titleCatalizador=false;
      this.titlePacto=true;
      this.titleLineas=true;
    }
     
      this.puntoPND({
        params: {
          idplannacionaldesarrollo: this.Dataplannacionaldesarrollo
            .idplannacionaldesarrollo,
        },
      })
    },

    cargardetalle(idnivelpnd,periodo)
    {
      let values = [];
      this.$store.dispatch("saveVrblesPND", values);

      this.$router.push({
        path: '/detalleplannacionaldesarrollo/' + this.Dataplannacionaldesarrollo
            .idplannacionaldesarrollo + '/' + this.DataPuntoSelecionado.idpunto + '/' + idnivelpnd +'/' + this.Dataplannacionaldesarrollo.periodo
      });
    }
  },
  created() {
    this.get_plannacionaldesarrollo();
  },
  computed: {
    ...mapGetters(["gpuntos", "gplanesnacionaldesarrollo", "gnivelpnd", "gnivelpndbypunto","gPNDJson"]),
  },
    

  watch: {

    gnivelpndbypunto:function() {
      this.DataPactosSeleccionados = [];
      this.DataPactosSeleccionados = this.gnivelpndbypunto;   
    },
    gplanesnacionaldesarrollo: function () {
      this.gplanesnacionaldesarrollo.forEach((element) => {
        this.DataCuatrenios.push(element);
      });
      this.Dataplannacionaldesarrollo = this.gplanesnacionaldesarrollo[0];
      console.log('Valor seleccionado wath :', this.Dataplannacionaldesarrollo.idplannacionaldesarrollo);
      this.puntoPND({
        params: {
          idplannacionaldesarrollo: this.Dataplannacionaldesarrollo
            .idplannacionaldesarrollo,
        },
      });
      this.get_nivelespnd({
        params: {
          idplannacionaldesarrollo: this.Dataplannacionaldesarrollo
            .idplannacionaldesarrollo,
          nivelconfigurado: 1,
        },
      });
    }
  },
};
</script>

<style>
.eventbtn:hover {
  /* background-color: silver; */
  border: 1px solid #ccc;
  background: #ddd;
  box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
</style>